import { Link } from "react-router-dom";
import Button from "./Button";
import "./Event.scss";

const Event = ({ title, image, zoom, link = false, children, details = "/" }) => {
	return (
		<article className={title}>
			<span className="bg" id={zoom}></span>
			<div className="content fixXSkew">
				{!link && (
					<>
						<img className="eventlogo" src={image} alt={title} />
						<span className="learnMore">
							<Button as={Link} href={details}>LEARN MORE</Button>
						</span>
					</>
				)}
				{children}
			</div>
		</article>
	);
};

export default Event;
